module.exports = __webpack_public_path__ + "static/media/check.80c17e8f.svg";